import { useTheme } from '@mui/material'
import FormControl from '@mui/material/FormControl'
import InputAdornment from '@mui/material/InputAdornment'
import TextField from '@mui/material/TextField'
import I18n from 'i18n-js'
import PropTypes from 'prop-types'
import { makeStyles } from 'tss-react/mui'

import Icon from '../Icon'

const useStyles = makeStyles()((theme) => ({
  root: {
    width: '100%',
    fontFamily: 'Lato, Helvetica',
  },
  input: {
    backgroundColor: theme.palette.common.white,
  },
}))

const Search = ({ onChange }) => {
  const { classes } = useStyles()
  const theme = useTheme()
  return (
    <FormControl className={classes.root}>
      <TextField
        className={classes.input}
        InputProps={{
          endAdornment: (
            <InputAdornment position={'end'}>
              <Icon color={theme.palette.grey[800]} icon={'search'} size={30} />
            </InputAdornment>
          ),
        }}
        label={I18n.t('shared.search')}
        margin={'none'}
        onChange={(e) => onChange(e.target.value)}
        placeholder={I18n.t('shared.search')}
        type={'search'}
      />
    </FormControl>
  )
}

Search.propTypes = {
  onChange: PropTypes.func,
}

Search.defaultProps = {}

export default Search
